import styled from 'styled-components';

var SelectContainer = styled.div.withConfig({
  displayName: "Select__SelectContainer",
  componentId: "sc-mjznt2-0"
})(["position:relative;background:inherit;"]);
var DropdownIconContainer = styled.div.withConfig({
  displayName: "Select__DropdownIconContainer",
  componentId: "sc-mjznt2-1"
})(["position:absolute;display:flex;align-items:center;justify-content:center;top:0;right:0;height:24px;pointer-events:none;background:inherit;"]);
var IconContainer = styled.div.withConfig({
  displayName: "Select__IconContainer",
  componentId: "sc-mjznt2-2"
})(["display:flex;align-items:center;justify-content:center;height:24px;pointer-events:none;"]);

export { DropdownIconContainer, IconContainer, SelectContainer };
